import { EntityModel } from '@/interfaces'
import {
  ALL_AVAILABLE_ADDONS_QUERY,
  CREATE_AVAILABLE_ADDON_MUTATION,
  DELETE_AVAILABLE_ADDON_MUTATION,
  FORCE_DELETE_AVAILABLE_ADDON_MUTATION,
  SINGLE_AVAILABLE_ADDON_QUERY,
  UPDATE_AVAILABLE_ADDON_MUTATION,
} from './graphql'
import mediaFileEntity from '@/entities/mediaFile/entity'

const accommodationAvailableAddonModel: EntityModel = {
  name: 'availableAddon',
  namePlural: 'availableAddons',
  uniqueName: 'accommodationAvailableAddon',
  uniqueNamePlural: 'accommodationAvailableAddons',
  path: 'travel/accommodation/available_addon',
  baseUrl: '/travel/accommodation/available_addons',
  translationPrefix: 'entities:accommodationAvailableAddon.',
  getDisplayName: (values: any) => {
    return values.name
  },
  gql: {
    getAll: ALL_AVAILABLE_ADDONS_QUERY,
    getSingle: SINGLE_AVAILABLE_ADDON_QUERY,
    create: CREATE_AVAILABLE_ADDON_MUTATION,
    update: UPDATE_AVAILABLE_ADDON_MUTATION,
    delete: DELETE_AVAILABLE_ADDON_MUTATION,
    forceDelete: FORCE_DELETE_AVAILABLE_ADDON_MUTATION,
  },
  attributes: {
    name: {
      name: 'name',
      label: 'entities:accommodationAvailableAddon.attributes.name.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    description: {
      name: 'description',
      label: 'entities:accommodationAvailableAddon.attributes.description.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'wysiwyg',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    icon: {
      name: 'icon',
      label: 'entities:accommodationAvailableAddon.attributes.icon.label',
      type: 'entityObject',
      dataType: 'any',
      getEntity: () => {
        return mediaFileEntity
      },
      defaultInput: false,
      inputType: 'select',
      validationType: 'string',
      validations: [],
    },
  },
}

export default accommodationAvailableAddonModel
